import type { FC } from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import Panel from '../../../components/global/Panel';
import PanelHeader from '../../../components/global/PanelHeader';
import PanelTitle from '../../../components/global/PanelTitle';
import PanelFilter from '../../../components/admin/PanelFilter';
import SeguimientoTerritorioDetail from './SeguimientoTerritorioDetail';
import { onGet } from '../../../store/actions/global';
import SeguimientoTerritorioConvenio from './SeguimientoTerritorioConvenio';

const SeguimientoTerritorio: FC<any> = ({ onGet: onGetExec }) => {
  const isMountedRef = useIsMountedRef();
  const title = 'Seguimiento Mensual de Convenios por Territorio';
  const [dataTerritorio, setDataTerritorio] = useState([]);
  const [convenio, setConvenio] = useState({
    data: [],
    resume: { operaciones: 0, facturacion: 0, meta: 0 },
    pages: { total: 0, current: 0, limit: 0 },
  });
  const [total, setTotal] = useState(0);
  const [valuesFilter, setValuesFilter] = useState({ year: null, month: null });
  const defaultLimit = 10;

  const onSubmit = async (values) => {
    if (isMountedRef.current) {
      setValuesFilter(values);
      const response = await onGetExec({
        url: '/dashboard/seguimiento-territorio',
        body: { ...values, limit: defaultLimit },
      });
      setDataTerritorio(response?.data);
      setTotal(response?.total);
      setConvenio(response?.convenio);
    }
  };

  const handleChangePageConvenio = async (event: unknown, page: number) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/seguimiento-territorio/detail',
      body: {
        year,
        month,
        limit: Number(convenio.pages.limit),
        page,
        type: 'CONVENIO',
      },
    });
    setConvenio(response);
  };

  const handleChangeRowsPerPageConvenio = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { year, month } = valuesFilter;
    const response = await onGetExec({
      url: '/dashboard/seguimiento-territorio/detail',
      body: {
        year,
        month,
        limit: Number(event.target.value),
        page: 0,
        type: 'CONVENIO',
      },
    });
    setConvenio(response);
  };

  return (
    <>
      <Helmet>
        <title>
          Dashboard:
          {title}
        </title>
      </Helmet>
      <Panel>
        <PanelHeader>
          <PanelTitle
            title={title}
            subTitlePrim="Dashboard"
            subTitleSec={title}
          />
        </PanelHeader>
        <PanelFilter onSubmit={onSubmit} yearMonth channels />
        <Grid container spacing={2} mt={1} justifyContent="center">
          <Grid item md={5} xs={12}>
            <SeguimientoTerritorioDetail
              content={dataTerritorio}
              total={total}
            />
          </Grid>
          <Grid item md={7} xs={12}>
            <SeguimientoTerritorioConvenio
              content={convenio}
              handleChangePage={handleChangePageConvenio}
              handleChangeRowsPerPage={handleChangeRowsPerPageConvenio}
            />
          </Grid>
        </Grid>
      </Panel>
    </>
  );
};

export default connect(null, {
  onGet,
})(SeguimientoTerritorio);
